import React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const RechargeBill = ({ ...props }) => {
  return (
    <Svg
      width={36}
      height={36}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M26.221 34.74H8.78c-.82 0-1.483-.665-1.483-1.484V2.854c0-.82.664-1.483 1.483-1.483H26.22c.82 0 1.483.664 1.483 1.483v30.402c0 .82-.664 1.483-1.483 1.483Z"
        fill="#2075F0"
      />
      <Path
        d="M8.972 4.076a1 1 0 0 1 1-1h15.056a1 1 0 0 1 1 1v27.958a1 1 0 0 1-1 1H9.972a1 1 0 0 1-1-1V4.076Z"
        fill="#8FC7FF"
      />
      <Path
        d="M19.503 4.58h-4.006a.816.816 0 0 1-.816-.816V1.371h5.638v2.393c0 .45-.365.816-.816.816Z"
        fill="#2075F0"
      />
      <Path
        d="m17.175 25.174.037-6.337H14.87l2.147-7.01h2.343l-1.645 5.281h2.415l-2.955 8.066Z"
        fill="#fff"
      />
      <Path
        d="M12.182 35.63H1.854c-.82 0-1.483-.665-1.483-1.484v-19.53c0-.82.664-1.483 1.483-1.483h10.328c.82 0 1.483.664 1.483 1.483v19.53c0 .82-.664 1.483-1.483 1.483Z"
        fill="#6CDF8C"
      />
      <Path
        d="M7.574 28.335H6.462a.37.37 0 1 1 0-.741h1.112a.37.37 0 1 1 0 .741ZM3.83 28.335H2.717a.37.37 0 1 1 0-.741H3.83a.37.37 0 1 1 0 .741ZM11.319 28.335h-1.112a.37.37 0 1 1 0-.741h1.112a.37.37 0 1 1 0 .741ZM8.872 25.962H5.164a.37.37 0 0 1 0-.741h3.708a.37.37 0 0 1 0 .741ZM7.574 31.005H6.462a.37.37 0 1 1 0-.742h1.112a.37.37 0 1 1 0 .742ZM3.83 31.005H2.717a.37.37 0 1 1 0-.742H3.83a.37.37 0 1 1 0 .742ZM11.319 31.005h-1.112a.37.37 0 1 1 0-.742h1.112a.37.37 0 1 1 0 .742ZM7.574 33.674H6.462a.37.37 0 1 1 0-.741h1.112a.37.37 0 1 1 0 .741ZM3.83 33.674H2.717a.37.37 0 1 1 0-.741H3.83a.37.37 0 1 1 0 .741ZM11.319 33.674h-1.112a.37.37 0 1 1 0-.741h1.112a.37.37 0 1 1 0 .741ZM2.346 15.186h9.344v8.157H2.346v-8.157Z"
        fill="#fff"
      />
      <G clipPath="url(#a)">
        <Path
          d="M33.97 28.28a7.72 7.72 0 1 1-15.44 0 7.72 7.72 0 0 1 15.44 0Z"
          fill="#F0CD00"
        />
        <Path
          d="M33.97 28.28a7.72 7.72 0 0 1-7.433 7.715 7.72 7.72 0 0 1 0-15.43 7.72 7.72 0 0 1 7.434 7.714Z"
          fill="#FFDE50"
        />
        <Path
          d="M32.25 28.28a6 6 0 0 1-11.999.073v-.074a6 6 0 1 1 11.998 0Z"
          fill="#EAB540"
        />
        <Path
          d="m30.492 24.037-8.484 8.484a6.006 6.006 0 0 1-1.34-2.04 5.974 5.974 0 0 1-.417-2.128v-.074a6 6 0 0 1 10.24-4.242Z"
          fill="#EAB540"
        />
        <Path
          d="M32.25 28.28a6 6 0 0 1-6.339 5.99 6 6 0 0 0 0-11.98 6 6 0 0 1 6.338 5.99Z"
          fill="#F68E00"
        />
        <Path
          d="M28.633 26.442h-1.05a2.536 2.536 0 0 0-.273-.66h1.323a.63.63 0 0 0 0-1.26H22.68a.63.63 0 1 0 0 1.26h2.432c.483 0 .904.267 1.125.66H22.68a.63.63 0 1 0 0 1.26h3.557a1.29 1.29 0 0 1-1.125.66H22.68a.63.63 0 0 0-.459 1.063l3.428 3.638a.628.628 0 0 0 .89.026.63.63 0 0 0 .027-.89l-2.426-2.576h.972c1.19 0 2.19-.818 2.472-1.92h1.05a.63.63 0 0 0 0-1.26Z"
          fill="#F68E00"
        />
        <Path
          d="M29.421 26.442h-1.05a2.532 2.532 0 0 0-.273-.66h1.323a.63.63 0 0 0 0-1.26h-5.954a.63.63 0 1 0 0 1.26h2.432c.483 0 .904.267 1.125.66h-3.557a.63.63 0 1 0 0 1.26h3.557a1.29 1.29 0 0 1-1.125.66h-2.432a.63.63 0 0 0-.459 1.063l3.428 3.638a.628.628 0 0 0 .89.026.63.63 0 0 0 .027-.89l-2.426-2.576h.972c1.19 0 2.19-.818 2.472-1.92h1.05a.63.63 0 1 0 0-1.26Z"
          fill="#FFEA94"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path
            fill="#fff"
            transform="translate(18.53 20.559)"
            d="M0 0h15.441v15.441H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default RechargeBill
